import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import warning from 'warning';
import TabPane from './TabPane';
import TabContent from './TabContent';
import ScrollTableBar from './ScrollTableBar';
import { getInstanceName } from '../_utils/reactUtils';

var getDefaultValue = function getDefaultValue(props) {
  var value;
  React.Children.forEach(props.children, function (child) {
    if (child && !value && !child.props.disabled) {
      value = child.props.name;
    }
  });
  return value;
};

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);

    _this.getTabIndex = function (value) {
      var tabIndex = 0;
      React.Children.forEach(_this.getValidChildren, function (child, index) {
        if (child && child.props && child.props.name === value) {
          tabIndex = index;
        }
      });
      return tabIndex;
    };

    _this.handleTabClick = function (name) {
      var onTabClick = _this.props.onTabClick;

      _this.setState({
        value: name
      });
      /* eslint-disable */


      onTabClick && onTabClick(name);
    };

    var value;

    if (props.value !== undefined) {
      value = props.value;
    } else if (props.defaultValue !== undefined) {
      value = props.defaultValue;
    } else {
      value = getDefaultValue(props);
    }

    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var value = this.state.value;

      var _a = this.props,
          type = _a.type,
          autoResize = _a.autoResize,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          placement = _a.placement,
          restProps = __rest(_a, ["type", "autoResize", "className", "style", "children", "placement"]);

      var index = this.getTabIndex(value);
      var validChildren = this.getValidChildren;

      if (validChildren && validChildren.length === 0) {
        return null;
      }

      var tabClx = classnames('roo-tabs', "roo-tabs-".concat(type), {
        'roo-tabs-flexable': autoResize,
        'roo-tabs-vertical': placement === 'left' || placement === 'right',
        'roo-tabs-vertical-right': placement === 'right',
        'roo-tabs-bottom': placement === 'bottom'
      }, className);
      return /*#__PURE__*/React.createElement("div", {
        className: tabClx,
        style: style
      }, /*#__PURE__*/React.createElement(ScrollTableBar, _Object$assign({}, restProps, {
        children: validChildren,
        autoResize: autoResize,
        tabIndex: index,
        value: value,
        type: type,
        placement: placement,
        onTabClick: this.handleTabClick
      })), /*#__PURE__*/React.createElement(TabContent, _Object$assign({}, restProps, {
        children: validChildren,
        value: value
      })));
    }
  }, {
    key: "getValidChildren",
    get: function get() {
      var children = this.props.children; // @ts-expect-error

      var validChildren = React.Children.map(children, function (child) {
        return child;
      }).filter(function (child) {
        // displayName 可能会被某些插件改写，所以做了两个 name 的判断
        if ( /*#__PURE__*/React.isValidElement(child) && (getInstanceName(child) === 'RooTabPane' || getInstanceName(child) === 'TabPane')) {
          return true;
        }

        warning(false, 'Roo Tabs: Tabs 内子元素只能为 TabPane');
        return false;
      });
      return validChildren;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.value !== undefined) {
        return {
          value: nextProps.value
        };
      }

      if (state.value === undefined) {
        return nextProps.defaultValue !== undefined ? {
          value: nextProps.defaultValue
        } : {
          value: getDefaultValue(nextProps)
        };
      }

      return null;
    }
  }]);

  return Tabs;
}(React.Component);

Tabs.propTypes = {
  type: PropTypes.oneOf(['card', 'fill', 'line']),
  autoResize: PropTypes.bool,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node,
  onTabClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  reRender: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'bottom', 'right', 'left'])
};
Tabs.defaultProps = {
  type: 'card',
  autoResize: false,
  defaultValue: undefined,
  value: undefined,
  children: [],
  onTabClick: function onTabClick() {},
  className: '',
  style: {},
  reRender: false,
  placement: 'top'
};
Tabs.Pane = TabPane;
polyfill(Tabs);
export default Tabs;